import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import ApiService from 'services/ApiService/ApiService';

import { PROFILE_OPTIONS } from './Api';


const PARSE_PERFORMER_INFO = 'cam4/studio/PARSE_PERFORMER_INFO';

const initialState = Immutable.fromJS({ profileOptions: [] });

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case PARSE_PERFORMER_INFO:
      return state.set('profileOptions', action.profileOptions);
    default:
      return state;
  }
}

export const NAME = 'profileOptions';

const profileOptions = (state) => state[NAME].get('profileOptions');

export const selector = createStructuredSelector({ profileOptions });

const translationMapping = {
  genders: 'profile.profile.gender.',
  sexPreferences: 'profile.profile.sexPreference.',
  ethnicities: 'profile.profile.ethnicity.',
  maritalStatuses: 'profile.profile.maritalStatus.',
  smokes: 'profile.profile.smoke.',
  drinks: 'profile.profile.drink.',
  hairColors: 'profile.profile.hairColor.',
  hairLengths: 'profile.profile.hairLength.',
  eyeColors: 'profile.profile.eyeColor.',
  bodyHairs: 'profile.profile.bodyHair.',
  facialHairs: 'profile.profile.facialHair.',
  bodyTypes: 'profile.profile.bodyType.',
  bodyDecorations: 'account.profileInfo.',
  timeZones: '',
  languageCodes: 'languages.',
  countryCodes: 'profile.country',
};

function addElementToPrefix(keyPrefix, value) {
  const obj = {};
  value.forEach((element) => {
    obj[element] = keyPrefix + element;
  });

  return obj;
}

function displayPerformeOptions(options) {
  return {
    type: PARSE_PERFORMER_INFO,
    profileOptions: options,
  };
}

function parseProfileInfo(data) {
  const parsedData = {};
  const secondaryData = {};

  Object.entries(data).forEach(([key, value]) => {
    if (translationMapping[key]) {
      const prefix = translationMapping[key];
      parsedData[key] = addElementToPrefix(prefix, value);
    }
  });

  Object.values(data.timeZones).forEach((value) => {
    secondaryData[value.timezoneID] = value.timezoneValue;
  });

  parsedData.timeZones = secondaryData;

  return (dispatch) => dispatch(displayPerformeOptions(parsedData));
}

function getProfileOptions() {
  return (dispatch) => ApiService.get(PROFILE_OPTIONS).then((res) =>
    dispatch(parseProfileInfo(res.data))
  );
}


export const actionCreators = { getProfileOptions };
